/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { FilterableDataSource } from '@shared/filterable-data-source/filterable-data-source';

export { FilterableDataSource };
